import { Fragment, useEffect, useRef } from "react";
import { ProductSkeletonLoader } from "./productSkeletonLoader";

// `paused` is the back-button restore replaying pages: it drives showMore() itself, so the
// observer here would only race it into skipping the page the saved card sits on.
export const DynamicLoader = ({ isGridView, isLastPage, showMore, currentPage, paused = false }) => {
  const loaderRef = useRef(null);
  const showMoreRef = useRef(showMore);

  useEffect(() => {
    showMoreRef.current = showMore;
  });

  useEffect(() => {
    if (isLastPage || paused) return;

    let pending = false;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          pending = false;
          return;
        }
        if (pending) return;
        pending = true;
        showMoreRef.current();
      },
      { root: null, rootMargin: "400px" },
    );

    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [isLastPage, currentPage, paused]);

  return (
    <Fragment>
      <div ref={loaderRef} className="dynamic-render-div col-lg-12">
        <ProductSkeletonLoader />
      </div>
    </Fragment>
  );
};
